const foundersSlider = new Swiper('.founders-slider', {
  slidesPerView: 1,
  loop: false,
  allowTouchMove: true,
  spaceBetween: 20,
  watchOverflow: true,
  pagination: {
    el: '.founders .swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.founders .swiper-button-next',
    prevEl: '.founders .swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 2.5,
      allowTouchMove: true,
      spaceBetween: 0,
    },
    1024: {
  slidesPerView: 3,
  allowTouchMove: true,
  spaceBetween: 0,
}
  }
});
function refreshFoundersSlider() {
  if (!foundersSlider || foundersSlider.destroyed) return;

  foundersSlider.update();

  if (foundersSlider.navigation) {
    foundersSlider.navigation.update();
  }
}

requestAnimationFrame(() => {
  requestAnimationFrame(refreshFoundersSlider);
});

if (document.readyState === 'complete') {
  refreshFoundersSlider();
} else {
  window.addEventListener('load', refreshFoundersSlider, { once: true });
}

const foundersResizeObserver = new ResizeObserver(() => {
  requestAnimationFrame(refreshFoundersSlider);
});

foundersResizeObserver.observe(foundersSlider.el);

foundersSlider.el.querySelectorAll('img').forEach((image) => {
  if (!image.complete) {
    image.addEventListener('load', refreshFoundersSlider, { once: true });
  }
});
